import { render, staticRenderFns } from "./modalApproveApprovalMPR.vue?vue&type=template&id=70634d4d&scoped=true"
import script from "./modalApproveApprovalMPR.vue?vue&type=script&lang=js"
export * from "./modalApproveApprovalMPR.vue?vue&type=script&lang=js"
import style0 from "./modalApproveApprovalMPR.vue?vue&type=style&index=0&id=70634d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70634d4d",
  null
  
)

export default component.exports